module.exports = __webpack_public_path__ + "static/img/float-left.94ac4fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/images/banner/float-left.png
// module id = s5nw
// module chunks = 1